export default (value, separator = ', ') =>
  value && value.join ? value.join(separator) : value
